import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { FaHeadset } from "react-icons/fa6";
import HRSupport from "./index";
import ViewTicketDetail from "./view";

const hrSupportRoutes = [	
    generateCRUDRoutes({
        mainTitle: "HR Support",
        basePath: "hr-support",
        mainComponent: <HRSupport />,
        layout: "/console",	   
        icon: <FaHeadset className="icon-item" />,
        viewComponent: <ViewTicketDetail />,
        subTitle:"HR Support",
        level:5,
        moduleId: 0,
    })
]

export default hrSupportRoutes;